/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import NewTable from '../../components/NewTable/NewTable';

const AltWalletHoldings = () => {
  const [swap, setSwap] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState('');
  const [activeTab, setActiveTab] = useState('PKRD'); 
  const cryptoTabs = ['PKRD', 'USDT', 'BNB', 'ETH', 'SOL', 'BTC'];

  const dummySwapData = [
    {
      walletAddress: "xxxxxxxxxx2541",
      holding: "20.724",
    },
    {
      walletAddress: "xxxxxxxxxx1452",
      holding: "1.210",
    },
    {
      walletAddress: "xxxxxxxxxx3698",
      holding: "145.00",
    },
    {
      walletAddress: "xxxxxxxxxx1478",
      holding: "200.178",
    },
    {
      walletAddress: "xxxxxxxxxx8520",
      holding: "400.000",
    }
  ];

  useEffect(() => {
    setSwap(dummySwapData);
  }, []);



  const tableHeadings = ['Wallet Address', 'Holding'];
  const tableRows = swap?.map((ele, index) => [
    ele?.walletAddress,
    ele?.holding
  ]);



  return (
    <div className='p-6 overflow-auto overflow-y-auto'>
      <h1 className="mb-4 text-[20px] font-[600] text-[#1D1F2C] ml-1">Alt Wallet Holdings</h1>
      <div className="flex mb-4">
        {cryptoTabs.map(tab => (
          <button
            key={tab}
            className={`px-4 py-2 font-medium ${activeTab === tab
              ? 'text-[#0F172A] border-b-[3px] border-green-600'
              : 'text-[#0F172A] hover:text-gray-800'
              }`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </button>
        ))}
      </div>
      <NewTable
        tableHeadings={tableHeadings}
        data={tableRows}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        showSearch={true}
        placeholder="Search by name, email, phone or ID..."
        showSorting={true}
        fromDate={fromDate}
        setFromDate={setFromDate}
        setToDate={setToDate}
        toDate={toDate}
        showDateFilter={false}
        showPageTopData2={false}
        showPageTopData1={false}
        showPageTopData3={false}
        showPageTopData4={false}
      />
    </div>
  );
};

export default AltWalletHoldings;

